module.exports = __webpack_public_path__ + "img/acms-recruit.70a40413.svg";